import { render, staticRenderFns } from "./VaListSeparator.vue?vue&type=template&id=0d3fe136&"
import script from "./VaListSeparator.vue?vue&type=script&lang=js&"
export * from "./VaListSeparator.vue?vue&type=script&lang=js&"
import style0 from "./VaListSeparator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports